import Cookies from 'js-cookie';

export const GCLID_COOKIE_NAME = 'gclid';

const isLocalDev = import.meta.env.DEV;

const GCLID_COOKIE_OPTIONS: Cookies.CookieAttributes = {
  ...(isLocalDev ? {} : { domain: 'conduithealth.com' }),
  path: '/',
  expires: 90,
  sameSite: 'Lax',
  secure: !isLocalDev,
};

/**
 * Captures Google Click ID (gclid) from URL parameters and stores in a cross-subdomain cookie.
 * Runs on module load (imported at top of main.tsx) to capture gclid before any React/router code.
 *
 * This enables conversion attribution for users who:
 * 1. Land directly on signup.conduithealth.com from a Google ad
 * 2. Land on conduithealth.com (Webflow) first, then navigate to signup
 */
function captureGclid() {
  if (typeof window === 'undefined') return;

  const params = new URLSearchParams(window.location.search);
  const gclidFromUrl = params.get('gclid');

  if (gclidFromUrl) {
    Cookies.set(GCLID_COOKIE_NAME, gclidFromUrl, GCLID_COOKIE_OPTIONS);
  }
}

// Capture immediately on module load, before React renders
captureGclid();
